import React from 'react';

import { CrmCustomFieldsBase } from './CrmCustomFieldsBase';

export class CrmContactsCustomFields extends CrmCustomFieldsBase {
  constructor(props) {
    super(props, {
      groupIdKey: 'settingscrmcontactsfields',
      pageTitleKey: 'crm-contacts-custom-fields',
    });
  }
}